import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-merchandise-details-skeleton',
  templateUrl: './merchandise-details-skeleton.component.html',
  styleUrls: ['./merchandise-details-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class MerchandiseDetailsSkeletonComponent {}
